import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { 
  HiOutlineLockClosed, HiOutlineArrowRight, 
  HiOutlineHome, HiOutlineSparkles,
  HiOutlineEye, HiOutlineEyeSlash // Add these two
} from "react-icons/hi2";
import { FcGoogle } from "react-icons/fc";
import "../asset/css/login.css";
import { baseurl } from "../baseurl";
import axios from "axios";
import Swal from "sweetalert2"; // Added for attractive alerts

const Login = () => {
  const [email, setEmail] = useState(""); // This acts as our 'identifier'
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Sending 'email' state as 'identifier' to match backend requirements
      const response = await axios.post(`${baseurl}/loginGuestUser`, {
        identifier: email,
        password: password
      });

      if (response.status === 200) {
        const userData = response.data.user;

        // 1. Console log the returned data
        console.log("Login Successful! User Data:", userData);

        // 2. Store in LocalStorage (stringified)
        localStorage.setItem("guestUser", JSON.stringify(userData));
        localStorage.setItem("guestUserId", response.data.user.userid); 

        // 3. Show Success Message
        Swal.fire({
          icon: 'success',
          title: 'Welcome Back!',
          text: response.data.message,
          timer: 2000,
          showConfirmButton: false
        });

        // 4. Navigate to dashboard or home
        setTimeout(() => {
          navigate("/");
        }, 2000);
      }
    } catch (err) {
      console.error("Login Error:", err.response?.data?.error || err.message);
      
      Swal.fire({
        icon: 'error',
        title: 'Login Failed',
        text: err.response?.data?.error || "Something went wrong. Please try again.",
        confirmButtonColor: "#166070"
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-hero-wrapper mt-5 ">
      <div className="container login-main-container">
        <div className="login-card shadow-2xl">
          <div className="row g-0 h-100">
            
            {/* --- LEFT HERO BRANDING --- */}
            <div className="col-lg-6 d-none d-lg-block side-hero-image">
              <div className="side-hero-overlay p-5 d-flex flex-column justify-content-center">
                <div className="hero-badge mb-4">
                  <HiOutlineSparkles className="me-2" /> Exclusive Access
                </div>
                <h1 className="display-4 fw-bold text-white mb-4">
                  Adventure <br /> Awaits You.
                </h1>
                <p className="text-white-50 lead mb-5">
                  Sign in to access your personalized travel dashboard, saved itineraries, and member-only pricing.
                </p>
                
                <div className="trust-indicators mt-auto">
                  <div className="d-flex align-items-center">
                    <span className="text-white small">Join 12,000+ happy travelers</span>
                  </div>
                </div>
              </div>
            </div>

            {/* --- RIGHT FORM SECTION --- */}
            <div className="col-lg-6 bg-white p-4 p-md-5 d-flex flex-column justify-content-center">
              <div className="form-content mx-auto" style={{maxWidth: "400px", width: "100%"}}>
                <div className="text-center mb-5">
                  <h2 className="fw-bold text-dark">Welcome Back</h2>
                  <p className="text-muted">Glad to see you again!</p>
                </div>

                <form onSubmit={handleLogin}>
                  <div className="form-floating-custom mb-4">
                    <label className="small fw-bold text-uppercase text-teal">Email or Phone</label>
                    <div className="input-with-icon">
                      <HiOutlineLockClosed className="icon" />
                      <input 
                        type="text" 
                        placeholder="e.g. wanderer@travel.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required 
                      />
                    </div>
                  </div>

                  <div className="form-floating-custom mb-3">
      <div className="d-flex justify-content-between">
        <label className="small fw-bold text-uppercase text-teal">Password</label>
        <Link to="/forgot" className="forgot-pass">Forgot?</Link>
      </div>
      <div className="input-with-icon position-relative">
        <HiOutlineLockClosed className="icon" />
        <input 
          type={showPassword ? "text" : "password"} // 2. Conditional Type
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required 
          className="pe-5" // Add padding to the right so text doesn't hit the icon
        />
        {/* 3. Toggle Button */}
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="position-absolute end-0 top-50 translate-middle-y border-0 bg-transparent me-3 text-muted"
          style={{ zIndex: 10, cursor: "pointer", padding: "5px" }}
        >
          {showPassword ? <HiOutlineEyeSlash size={20} /> : <HiOutlineEye size={20} />}
        </button>
      </div>
    </div>

                  <button 
                    type="submit" 
                    className="btn-hero-login w-100 mt-3"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Unlocking..." : "Unlock Journey"} 
                    {!isSubmitting && <HiOutlineArrowRight className="ms-2" />}
                  </button>

                  <div className="login-separator my-4">
                    <span>Quick Login</span>
                  </div>

                  <button type="button" className="btn-google-login w-100">
                    <FcGoogle className="me-3 fs-4" /> Sign in with Google
                  </button>
                </form>

                <p className="text-center mt-5 mb-0 text-muted">
                  New to the club? <Link to="/register" className="fw-bold text-teal text-decoration-none">Create Account</Link>
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;